// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const asmens: CountryValidator<"LT"> = createValidator(
  "lt.asmens",
  116,
);

export default asmens;
export const compact = asmens.compact;
export const format = asmens.format;
export const validate = asmens.validate;
export const generate = (): string =>
  asmens.generate?.() ??
  (() => {
    throw new Error(
      "Validator lt.asmens cannot generate values",
    );
  })();
